<template>
  <div class="guide-wrapper">
    <div class="guide-title">
      {{ $t("stake.guide") }}
    </div>
    <div class="guide-content">
      <div class="url" @click="() => jumpTo($t('onto.url'))">{{ $t("onto.guideText") }}</div>
      <div class="url" @click="() => jumpTo($t('owallet.url'))">{{ $t("owallet.guideText") }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StakeGuide",
  methods: {
    jumpTo(url) {
      window.open(url, '_blank')
    }
  }
};
</script>
<style lang="scss" scoped>
.guide-wrapper {
  max-width: 1200px;
  margin: auto;
  padding: 80px 0 120px 0;
  @include mobile {
    max-width: 100%;
    padding: 80px 20px 100px 20px;
  }
}
.guide-title {
  margin-bottom: 24px;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  color: #181717;
  line-height: 29px;
  text-align: center;
  letter-spacing: -0.03em;
  font-family: 'Inter';
}
.guide-content {
  display: flex;
  justify-content: space-between;
}
.url {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(50% - 12px);
  height: 220px;
  background: #ffffff;
  font-weight: 700;
  font-size: 32px;
  line-height: 120%;
  color: #181717;
  letter-spacing: -0.03em;
  box-sizing: border-box;

  @include mobile {
    width: calc(50% - 10px);
    height: 128px;
    font-size: 20px;
    padding: 40px 10px;
  }
}
</style>
